export const LOGO_URL = "/logo.jpeg";

export const CONTACT = {
  phone: "+91 7349707349",
  phoneHref: "tel:+917349707349",
  email: "info@trivenaexim.com",
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -84 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const NAV_LINKS = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Services", id: "services" },
  { label: "Team", id: "team" },
  { label: "Contact", id: "contact" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1496347326319-2935d381b307?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxjb250YWluZXIlMjBzaGlwJTIwY2FyZ28lMjBwb3J0JTIwb2NlYW4lMjBzdW5zZXQlMjBhZXJpYWx8ZW58MHx8fHwxNzkwNDIzMTA3fDA&ixlib=rb-4.1.0&q=85",
  about: "https://images.unsplash.com/photo-1568347877321-f8935c7dc5a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxjb250YWluZXIlMjBzaGlwJTIwY2FyZ28lMjBwb3J0JTIwb2NlYW4lMjBzdW5zZXQlMjBhZXJpYWx8ZW58MHx8fHwxNzkwNDIzMTA3fDA&ixlib=rb-4.1.0&q=85",
  customs:
    "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA1MTN8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjB3YXJlaG91c2UlMjBsb2dpc3RpY3MlMjBkaXN0cmlidXRpb24lMjBjZW50ZXIlMjBhdXRvbWF0aW9ufGVufDB8fHx8MTc5MDQyMzEwN3ww&ixlib=rb-4.1.0&q=85",
  freight:
    "https://images.unsplash.com/photo-1594110336951-5bc8c12d6b27?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxjb250YWluZXIlMjBzaGlwJTIwY2FyZ28lMjBwb3J0JTIwb2NlYW4lMjBzdW5zZXQlMjBhZXJpYWx8ZW58MHx8fHwxNzkwNDIzMTA3fDA&ixlib=rb-4.1.0&q=85",
  logistics:
    "https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA1MTN8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjB3YXJlaG91c2UlMjBsb2dpc3RpY3MlMjBkaXN0cmlidXRpb24lMjBjZW50ZXIlMjBhdXRvbWF0aW9ufGVufDB8fHx8MTc5MDQyMzEwN3ww&ixlib=rb-4.1.0&q=85",
  warehousing:
    "https://images.unsplash.com/photo-1684695749267-233af13276d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA1MTN8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjB3YXJlaG91c2UlMjBsb2dpc3RpY3MlMjBkaXN0cmlidXRpb24lMjBjZW50ZXIlMjBhdXRvbWF0aW9ufGVufDB8fHx8MTc5MDQyMzEwN3ww&ixlib=rb-4.1.0&q=85",
  storage:
    "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA1MTN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB3YXJlaG91c2UlMjBsb2dpc3RpY3MlMjBkaXN0cmlidXRpb24lMjBjZW50ZXIlMjBhdXRvbWF0aW9ufGVufDB8fHx8MTc5MDQyMzEwN3ww&ixlib=rb-4.1.0&q=85",
};

export const ABOUT_HIGHLIGHTS = [
  {
    icon: "Compass",
    title: "Expertise",
    text: "Experienced professionals and industry knowledge.",
  },
  {
    icon: "BadgeCheck",
    title: "Reliable Solutions",
    text: "Efficient and practical trade and logistics support.",
  },
  {
    icon: "FileCheck2",
    title: "Compliance Support",
    text: "Assistance with customs, documentation and GST-related matters.",
  },
  {
    icon: "HeartHandshake",
    title: "Customer Focus",
    text: "Personalized service and dedicated support.",
  },
];

export const SERVICES = [
  {
    key: "customs-clearance",
    title: "Customs Clearance",
    image: IMAGES.customs,
    text: "Fast and professional customs clearance supported by experienced professionals who understand customs regulations and documentation requirements.",
  },
  {
    key: "freight-forwarding",
    title: "Freight Forwarding",
    image: IMAGES.freight,
    text: "Efficient freight forwarding and shipping solutions through our network of leading freight forwarding agencies and international partners.",
  },
  {
    key: "logistics",
    title: "Logistics",
    image: IMAGES.logistics,
    text: "Streamlined transportation and supply-chain solutions designed for timely delivery and cost-effective operations.",
  },
  {
    key: "warehousing",
    title: "Warehousing",
    image: IMAGES.warehousing,
    text: "Flexible storage and warehousing solutions with multiple storage options and appropriate handling and inspection standards.",
  },
  {
    key: "storage",
    title: "Storage",
    image: IMAGES.storage,
    text: "Reliable, scalable and cost-effective storage solutions supporting smooth transportation and supply-chain operations.",
  },
  {
    key: "packaging",
    title: "Packaging",
    image: IMAGES.customs,
    text: "Professional packaging solutions designed to help ensure safe handling and transportation of goods.",
  },
];

export const TEAM = [
  { name: "Snehal Prakash Narkar", role: "Director", image: "/team-snehal.png" },
  { name: "Shalini Pravin Singh", role: "Director", image: "/team-shalini.png" },
];
